import React from "react";

export const HeartReactionIcon = () => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path id="Vector" d="M10.9594 0.0838336C9.75857 -0.208832 8.12283 0.211214 7.00411 2.1998C5.88331 0.211206 4.24737 -0.208832 3.04234 0.0838336C1.5451 0.450323 0.5 1.8468 0.5 3.48009C0.5 6.11666 2.48195 8.01141 4.77779 10.2057C5.08507 10.4984 5.3425 10.7553 5.5611 10.9744C6.24702 11.658 6.62346 12 7 12C7.37654 12 7.75296 11.6582 8.43891 10.9744C8.65741 10.7554 8.91493 10.5007 9.22221 10.2057C11.5179 8.01821 13.5 6.1279 13.5 3.48009C13.5 1.8445 12.4549 0.447974 10.9577 0.0838336H10.9594Z" fill="currentColor"/>
  </svg>
);
